import { Modal, useIntl } from 'platform-components/common';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { customLessonInfoModalActions } from 'common.components/custom-lesson-info-modal/actions';
import { getInfoLandingLink } from 'common.components/custom-lesson/utils';

import { CustomLessonInfoModalContent } from './__content/custom-lesson-info-modal__content';
import { getShouldShowModal } from './selectors';

import './custom-lesson-info-modal.scss';

export const CustomLessonInfoModal = () => {
    const shouldShowModal = useSelector(getShouldShowModal);
    const dispatch = useDispatch();
    const intl = useIntl();
    const link = getInfoLandingLink(intl);

    const handleClose = useCallback(() => {
        dispatch(customLessonInfoModalActions.hide());
    }, [dispatch]);

    if (!link) {
        return null;
    }

    return (
        <Modal
            autoclosable
            hasClose
            mix="custom-lesson-info-modal"
            onRequestClose={handleClose}
            opened={shouldShowModal}
            scrollToTop
            useScale={false}
        >
            <CustomLessonInfoModalContent src={link} />
        </Modal>
    );
};
